<p
  *ngIf="isVisible"
  class="tooltip"
  [ngStyle]="{ left: coords.x, top: coords.y }"
  [innerHtml]="(text | translate)"
>

</p>
